import {
    FooterTag,
    Anchor,
    P
} from './styled'

export const Footer = () => (
    <FooterTag>
        <P>
            &copy;&nbsp;Coded by <Anchor rel="noopener noreferrer" target='_blank' href='https://github.com/ransomware3'>Natan Iori</Anchor>
        </P>
    </FooterTag>
)